import { render, staticRenderFns } from "./Step2AddToCoverForm.vue?vue&type=template&id=edfc9490&"
import script from "./Step2AddToCoverForm.vue?vue&type=script&lang=js&"
export * from "./Step2AddToCoverForm.vue?vue&type=script&lang=js&"
import style0 from "./Step2AddToCoverForm.vue?vue&type=style&index=0&id=edfc9490&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports